import React, { useEffect  } from "react";

import Sidebar from "component/Sidebar";
import Navbar from "component/Navbar";
import Content from "component/dashboard/Content";
import Calendar from "component/dashboard/Calendar";

function Dashboard() {
  useEffect(() => {
    document.title = "Green Hill Kemuning | Dashboard";
    window.scrollTo(0, 0);
  }, []);
  
  return (
    <div class="layout-wrapper layout-content-navbar">
      <div class="layout-container">
        <Sidebar />

        <div class="layout-page" style={{ backgroundColor: "#f8f9fa" }}>
            <Navbar />            
            <div class="content-wrapper">
                <div class="container-xxl flex-grow-1 container-p-y">
                <Content/> 
                <Calendar/> 
                </div>
            </div>
        </div>
      </div>
      <div class="layout-overlay layout-menu-toggle"></div>
    </div>
  );
}

export default Dashboard;
